export enum TableAction {
  add = 'add',
  view = 'view',
  edit = 'edit',
  delete = 'delete',
  deleteAll = 'deleteAll',
  active = 'active',
  config = 'config',
  user = 'user',
  params = 'params',
  lock = 'lock',
  signIn = 'signIn',
}

export const getCustomClasses = (configs, cKey) => {
  if (!configs || (configs && configs.length === 0)) {
    return '';
  }
  const config = configs.find(config => config.key === cKey);
  if (!config) {
    return '';
  }
  const { classes } = config;
  return classes;
};
export const getViewHeight = viewHeight => {
  return `table-vh-${viewHeight}`;
};



// WEBPACK FOOTER //
// ./src/app/components/table-component/table.const.ts